import React from 'react'

function Nosotros() {
    return (
        <div>nosotros</div>
    )
}

export default Nosotros;
